import _axios from '@/plugins/axios';
import { UsersError } from '@/lib/Errors';

export default {
	async getItemCatalogs () {
		const response = await _axios.get('inventory/itemModel');
		if (response.data.resFlag) {
			return response.data.data;
		} else if (response.data.msg === 'No inventory item models found.') {
			return [];
		}
		throw new UsersError('Error getting item models!');
	},
	async getItemCatalogById (id) {
		const response = await _axios.get(`inventory/itemModel/${id}`);
		if (response.data.resFlag) {
			return response.data.data;
		}
		throw new UsersError('Error getting item model!');
	},
	async getInventoryItemCategoryOptions () {
		const response = await _axios.get('inventory/itemModel/getInventoryItemCategoryOptions');
		if (response.data.resFlag) {
			return response.data.data;
		}
		throw new UsersError('Error getting item category options!');
	},
	async addItemCatalog (body) {
		const response = await _axios.post('inventory/itemModel', body);
		if (response.data.resFlag) {
			return response.data.data;
		}
		throw new UsersError('Error adding item model!');
	},
	async editItemCatalog (body) {
		const response = await _axios.put(`inventory/itemModel/${body.id}`, body);
		if (response.data.resFlag) {
			return response.data.data;
		}
		throw new UsersError('Error editing item model!');
	},
	async deleteItemCatalog (id) {
		const response = await _axios.delete(`inventory/itemModel/${id}`);
		if (response.data.resFlag) {
			return response.data.data;
		}
		throw new UsersError('Error deleting item model!');
	},
};
